import React, { useState } from "react";
import ReactDataGrid from "react-data-grid";
import { Toolbar, Data, Filters } from "react-data-grid-addons";
import NumberInput from "./NumberInput"


class ShowFilter extends React.Component {

    componentDidMount() {
        this.props.onToggleFilter();
    }
    render(props) {
        return null;
    }
}

const defaultColumnProperties = {
    resizable: true
};

const selectors = Data.Selectors;
const {
    MultiSelectFilter,
} = Filters;


const ROW_COUNT = 50;

const handleFilterChange = filter => filters => {
    const newFilters = { ...filters };
    if (filter.filterTerm) {
        newFilters[filter.column.key] = filter;
    } else {
        delete newFilters[filter.column.key];
    }
    return newFilters;
};

function getValidFilterValues(rows, columnId) {
    return rows
        .map(r => r[columnId])
        .filter((item, i, a) => {
            return i === a.indexOf(item);
        });
}

function getRows(rows, filters) {
    return selectors.getRows({ rows, filters });
}

function OrderTable({ rows, columns, onGridRowsUpdated, handleChangeCustom }) {
    const [filters, setFilters] = useState({});
    const filteredRows = getRows(rows, filters);
    return (
        <ReactDataGrid
            columns={columns}
            rowGetter={i => filteredRows[i]}
            rowsCount={filteredRows.length}
            onGridRowsUpdated={onGridRowsUpdated}
            enableCellSelect={true}
            onColumnResize={(idx, width) =>
                console.log(`Column ${idx} has been resized to ${width}`)
            }
            toolbar={<ShowFilter />}
            onAddFilter={filter => setFilters(handleFilterChange(filter))}
            onClearFilters={() => setFilters({})}
            getValidFilterValues={columnKey => getValidFilterValues(rows, columnKey)}
            minHeight={500}
        />
    );
}
export default OrderTable;